import { Link } from "react-router-dom";
import "./StatsCard.css";

interface StatsCardProps {
  title: string;
  value: number;
  icon: string;
  color: "orange" | "blue" | "green" | "purple";
  link?: string;
}

const StatsCard = ({ title, value, icon, color, link }: StatsCardProps) => {
  const content = (
    <div className="stats-card-content">
      <div className="stats-card-header">
        <div className={`stats-icon ${color}`}>
          <span>{icon}</span>
        </div>
        <h3 className="stats-title">{title}</h3>
      </div>
      <div className="stats-value">{value}</div>
    </div>
  );

  // Use consistent wrapper element
  return link ? (
    <Link to={link} className={`stats-card ${color}`}>
      {content}
    </Link>
  ) : (
    <div className={`stats-card ${color}`}>{content}</div>
  );
};

export default StatsCard;
